export default {"src":"/_next/static/media/DemystLogo.eecb519f.svg","height":71,"width":514};